module.exports = __webpack_public_path__ + "static/media/publishing_hero.57cbf6e0.webp";